var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.857,
    height: 24,
    viewBox: "0 0 18.857 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-51.2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M64.914,6a.857.857,0,0,1-.857-.857V0H53.771A2.571,2.571,0,0,0,51.2,2.571V21.429A2.571,2.571,0,0,0,53.771,24H67.486a2.571,2.571,0,0,0,2.571-2.571V6Z",
    transform: "translate(-51.2)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.771 0.502)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M341.333,10v3.783h3.783Z",
    transform: "translate(-341.333 -10.001)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.49f8b1fd.svg";
export { ForwardRef as ReactComponent };